import { FC, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Langs } from "../../domain/enums/common/LangsEnum";
import languageServiceFactory from "../../services/LanguageServiceImpl";
import CustomLangIcon from "../../custom-components/CustomLangIcon";
import { useClickOutOfElement } from "../../custom-hooks/base-hooks/useClickOutOfElement";

const langService = languageServiceFactory();

interface ConsoleLangSelectProps {
    isExpanded: boolean;
    isOpen: boolean;
    setIsOpen: (open: boolean) => void;
}

const ConsoleLangSelect: FC<ConsoleLangSelectProps> = ({ isExpanded, isOpen, setIsOpen }) => {
    const { t, i18n } = useTranslation();
    const popupRef = useRef(null);

    useClickOutOfElement(popupRef, () => setIsOpen(false));

    if (!isOpen) return null;

    const languages: Langs[] = [Langs.UA, Langs.EN];
    const currentLang = i18n.language as Langs;
    const popupPositionClasses = isExpanded ? "left-[265px] top-[60px]" : "left-[65px] top-[60px]";

    const changeLanguage = (lang: Langs) => {
        i18n.changeLanguage(lang);
        langService.setCurrentLang(lang);
        langService.notifyListeners(lang);
        setIsOpen(false);
    };

    return (
        <div
            ref={popupRef}
            className={`absolute ${popupPositionClasses} bg-light-bg-1000 dark:bg-dark-bg-100 shadow-lg border border-light-border-400 dark:border-dark-border-400 rounded-md w-[165px] z-50 p-2`}
        >
            <ul className="flex flex-col gap-2">
                {languages.map((lang) => (
                    <li
                        key={lang}
                        onClick={() => changeLanguage(lang)}
                        className="cursor-pointer px-2 py-1 rounded text-[16px] text-light-text-200 dark:text-dark-text-500 hover:bg-gray-200 dark:hover:bg-dark-bg-100 flex items-center gap-2"
                    >
                        <CustomLangIcon className="w-4 h-4" lang={lang} />
                        <span className={lang === currentLang ? "font-bold" : ""}>{t(`languages.${lang}`)}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ConsoleLangSelect;
